export default [
    {
        icon: 'sub-rights-1.png',
        name: '优惠券',
        content: '· 权益内容：优惠券为价值400元抵扣券，用于抵扣车辆订阅费用。\n\n· 发放规则：在极氪订阅联合特权权益（以下简称“权益”）有效期内，极氪订阅将向您按月发放优惠券共计12张，您购买权益当日，极氪订阅将向您发放首张优惠券， 剩余优惠券将按月发放，每个自然月首日将发放一张。\n\n· 使用规则：\n1.本抵扣券仅限在极氪订阅APP使用，每单限使用一张，您应当在支付时进行勾选。\n2.优惠券有效期为一个月，自发放之日起生效，过期后即失效。\n3.优惠券仅限您本人使用，不可转让，不可找零，不可兑现。\n4.优惠券不可叠加，不可和其他活动同时使用。'
    },
    {
        icon: 'sub-rights-2.png',
        name: '整备服务',
        content: '· 整备费一价全包，不另外收取车辆整备的人工费、场地费等基础服务费（不包含车辆使用中因内饰污渍产生的清洁费用）。'
    },
    {
        icon: 'sub-rights-3.png',
        name: '基础备品',
        content: '· 订阅期间，随车辆提供免费基础备品。如提供消耗品（如饮品、纸巾、口罩）的，您无需归还，如提供数据线、雨伞、号码牌、灭火器、破窗锤等物品的，须随车归还。备品具体内容以交车单记载内容为准。'
    },
    {
        icon: 'sub-rights-4.png',
        name: '出行保障',
        content: '· 订阅期间，在正常驾驶中出现车损事故，您无需承担保险理赔范围内的本车损失、三者200万元以内的损失、本车乘客人员伤亡每座5万以内的损失;\n\n· 当您申请享受上述服务时，您需要联系并在公司工作人员指导下配合提供交通事故认定书、现场照片等保险理赔所需资料;如您不配合提供或提供的资料不符合条件，您可能不能享受到相关免赔服务（具体内容以您订阅车辆时签署的《订阅须知》为准）。'
    },
    {
        icon: 'sub-rights-5.png',
        name: '免责权益',
        content: '· 除车辆保险以外，为您另行提供免责权益（轮胎/轮毂受损不享受此权益），即因在正常驾驶中出现车损事故造成本车损失小于等于3000元时，您无须支付理赔费用(包括保险上浮/逾期占用/损伤维修费用)。'
    },
    {
        icon: 'sub-rights-6.png',
        name: '专属管家',
        content: '· 订阅期间专属订阅服务管家为您提供7*24小时在线服务。'
    },
    {
        icon: 'sub-rights-7.png',
        name: '延时还车',
        content: '· 2小时内延迟还车免收费用。'
    },
    {
        icon: 'sub-rights-8.png',
        name: '还车无忧',
        content: '· 还车方式为门店还车的，电量不低于SOC的10%，不收取任何电量费用；低于SOC的10%则收取50元充电服务费。'
    },
    {
        icon: 'sub-rights-9.png',
        name: '充电补能',
        content: '· 享一定金额的充电额度和代客充电权益，详见订阅选配页“订阅特权”说明。'
    },
    {
        icon: 'sub-rights-10.png',
        name: '权益+',
        content: '· 生态权益持续更新阶段性提供，不限于极氪饮品等权益，详见订阅选配页“订阅特权”说明。'
    },
]